import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { UncontrolledPopover, PopoverBody, Button } from 'reactstrap'
import { Link } from 'react-router-dom'

import { uuidv4, getFeature, trans } from "@utils"

import { UpgradePlanIcon } from "@csrc/assets/icons"

const UpgradeTooltip = props => {
    const {id = null, internalTrigger = false, internalTriggerProps = {}, placement = 'top', featureKey} = props
    const uuid = uuidv4()
    const generatedId = id ?? `upgrade_tooltip_${uuid.replaceAll('-', '')}`
    const feature = getFeature(featureKey)
    return (
        <>
            {
                internalTrigger && (
                    <span id={generatedId} className={_.get(internalTriggerProps, 'className', 'ml-2')}>
                        <FontAwesomeIcon icon={UpgradePlanIcon}/>
                    </span>
                )
            }
            <UncontrolledPopover
                // isOpen={true}
                placement={placement}
                target={generatedId}
                trigger={'hover'}
                className={'UpgradePlanPopover'}
            >
                <PopoverBody className={'d-flex'}>
                    <span className={'px-50'} style={{ whiteSpace: 'nowrap' }}>{trans('gen.planing.requirePlan', { require: feature.require })}</span>
                    <Button
                        size={'sm'}
                        color={'primary'}
                        className={'ml-25'}
                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                        onClick={e => {
                            e.stopPropagation()
                            e.preventDefault()
                            window.open('/workspace/settings/plans', '_blank')
                        }}
                    >
                        <span style={{ whiteSpace: 'nowrap' }}>{trans('gen.actions.upgrade')}</span>
                    </Button>
                </PopoverBody>
            </UncontrolledPopover>
        </>
    )
}

UpgradeTooltip.propTypes = {}

export default UpgradeTooltip
